export default __webpack_public_path__ + "971b0cbf8b2801a29b507fd40ed564ca.png";